import script from "./LandingPageWorkLocation.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingPageWorkLocation.vue?vue&type=script&setup=true&lang=js"

import "./LandingPageWorkLocation.vue?vue&type=style&index=0&id=7f2ac654&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f2ac654"]])

export default __exports__